import "./NotFound.css";
import imagen from "../../assets/NotFound.jpg";
import Nav from "../nav/Nav";
import Footer from "../footer/Footer";
import BtnWhatsapp from "../btnWhatsapp/BtnWhatsapp";

const NotFound = () => {
  return (
    <>
      <Nav />
      <div className="not-found">
        <img src={imagen} alt="Not Found" />
      </div>
      <Footer />
      <BtnWhatsapp />
    </>
  );
};

export default NotFound;
